export default __webpack_public_path__ + "static/media/winnie.b17ec872.jpg";